import { render } from "./OrdersPage.vue?vue&type=template&id=db7099bc"
import script from "./OrdersPage.vue?vue&type=script&lang=ts"
export * from "./OrdersPage.vue?vue&type=script&lang=ts"
script.render = render

export default script